import React from 'react';
import { useLoaderData } from 'react-router-dom';
import HeaderBaner from '../headerBaner/HeaderBaner';
import QuizItem from '../quizItem/QuizItem';

const Topics = () => {
    const QuizDatas = useLoaderData();
const QuizData = QuizDatas.data

    return (
        <div>
            <HeaderBaner></HeaderBaner>

            <div className='grid gap-5 mx-3 mt-4 lg:grid-cols-4 md:grid-cols-2 '>
            {
                QuizData.map(quizitem => <QuizItem key={quizitem.id} quizitem={quizitem}></QuizItem>)
            } 
            </div>
        </div>
    );
};

export default Topics;